import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import CommonState from '@/class/cargo/model/parameters/CommonState'

/**
 * ImportConstants 常量定义
 */

// ------------------------------
// 海运进口业务模式查询页面显示
// ------------------------------
export const FCL = new CommonState('FCL', '整箱', 'Full Container Load')
export const LCL = new CommonState('LCL', '拼箱', 'Less Than Container Load')
export const CON = new CommonState('CON', '集拼', 'Consolidation')
export const POJ = new CommonState('POJ', '项目', 'Project')
export const PVE = new CommonState('PVE', '私人物品', 'Personal Items')
export const ECL = new CommonState('ECL', '委托拼箱', 'Entrust the LCL')
export const BULK_CARGO_TYPE = new CommonState('BULK', '散杂货', 'BULK')

/**
 * 海运进口整拼类型
 */
export const _cargoTypeInputList = ([FCL, LCL, CON, POJ, PVE, ECL, BULK_CARGO_TYPE])

// ----------------------------
// 空运进口业务模式输入显示
// ----------------------------
export const CONSOLE = new CommonState(0, '一主多分', 'Console')
export const DIRECT = new CommonState(1, '直单', 'Direct')
export const BACK_TO_BACK = new CommonState(2, '一主一分', 'Back To Back')

/**
 * 空运进口操作模式
 */
export const _cargoTypeAirInputList = ([CONSOLE, DIRECT, BACK_TO_BACK])

// -----------------------------------
// 进口业务状态
// -----------------------------------
export const BUSINESS_ALL = new CommonState(100, '【全部】', 'All')
export const BUSINESS_OPERATING = new CommonState(0, '正操作', 'Operating')
export const BUSINESS_PRE_SUBMIT = new CommonState(11, '预提交', 'Pre Submit')
export const BUSINESS_SUBMIT = new CommonState(1, '已提交', 'Submit')
export const BUSINESS_AUDIT = new CommonState(2, '已审核', 'Audit')
export const BUSINESS_INVALID = new CommonState(99, '已作废', 'Invalid')

/**
 * 进口业务状态
 */
export const _importBusinessStates = ([BUSINESS_ALL, BUSINESS_OPERATING, BUSINESS_PRE_SUBMIT, BUSINESS_SUBMIT, BUSINESS_AUDIT, BUSINESS_INVALID])

// ------------------------------------------------
// 进口货物类型
// ------------------------------------------------
export const CARGOTYPE_ALL = new CommonState('', '【全部】', 'All')
export const CARGOTYPE_DANGEROUS = new CommonState('DG', '危险品', 'Dangerous Goods')
export const CARGOTYPE_GOH = new CommonState('GOH', '挂衣箱', 'GOH')
export const CARGOTYPE_GENERAL = new CommonState('GC', '普货', 'General Cargo')
export const CARGOTYPE_BULKY = new CommonState('BB', '大件货', 'Bulky Goods')
export const CARGOTYPE_CONTROL = new CommonState('RF', '温控货物', 'Temperature Control Of Goods')

/**
 * 进口货物类型
 */
export const _importCargoTypes = ([CARGOTYPE_ALL, CARGOTYPE_DANGEROUS, CARGOTYPE_GOH, CARGOTYPE_GENERAL, CARGOTYPE_BULKY, CARGOTYPE_CONTROL])

export const CARGOTYPE_CHEMICAL = new CommonState('CM', '一般化工品', 'Chemical')
export const CARGOTYPE_OOG = new CommonState('OOG', 'OOG', 'OOG')
export const CARGOTYPE_FROZEN = new CommonState('FG', '冷冻货', 'Frozen Cargo')

// ------------------------------------------------
// 进口放单方式
// ------------------------------------------------
export const RELEASETYPE_ALL = new CommonState(-1, '【全部】', 'All')
export const RELEASETYPE_ORIGINAL = new CommonState(0, '正本提单', 'Original Bill Of Lading')
export const RELEASETYPE_CALL = new CommonState(1, '电放', 'SURRENDERED')
export const RELEASETYPE_WAYBILL = new CommonState(2, 'SEA WAYBILL', 'SEA WAYBILL')

/**
 * 进口放单方式
 */
export const _importReleaseTypes = ([RELEASETYPE_ALL, RELEASETYPE_ORIGINAL, RELEASETYPE_CALL, RELEASETYPE_WAYBILL])

/**
 * 放货方式
 */
export const CargoReleaseTypes = [RELEASETYPE_ORIGINAL, RELEASETYPE_CALL, RELEASETYPE_WAYBILL]
// 进口放单方式
// ------------------------------------------------
export const SETTLEMENTTYPE_TIC = new CommonState(0, '票结', 'Ticket settlement')
export const SETTLEMENTTYPE_NOTTIC = new CommonState(1, '非票结', 'Non invoice settlement')

/**
 * 进口放单方式
 */
export const settlemenType = ([SETTLEMENTTYPE_TIC, SETTLEMENTTYPE_NOTTIC])

/**
 * @public
 * 业务类型 海/空运进口
 */
export function stateLabelFunc(data, column) {
  var value = data[column]
  if (Job(data).isBlocked) {
    return '已锁定'
  } else {
    if (value === 0) {
      return '正操作'
    } else if (value === 1) {
      return '已提交'
    } else if (value === 2) {
      return '已审核'
    } else if (value === 3) {
      return '已退关'
    } else if (value === -1) {
      return '待审核'
    } else if (value === 11) {
      return '预提交'
    } else if (value === 12) {
      return '已拒绝'
    }
  }
  return '状态未知'
}

/**
 * @public
 * 业务类型 海运进口
 */
export function containerTypeLabFun(data, column) {
  if (data.containerLoadType === 'FCL') {
    return '整箱'
  } else if (data.containerLoadType === 'LCL') {
    return '拼箱'
  } else if (data.containerLoadType === 'CON') {
    return '集拼'
  } else if (data.containerLoadType === 'POJ') {
    return '项目'
  } else if (data.containerLoadType === 'ECL') {
    return '委托拼箱'
  } else {
    return '私人物品'
  }
}

/**
 * @public
 * 海运出口整拼类型labelFunction
 * 匹配不上则返回""
 */
export function containerTypeStrLabFun(data, column) {
  var containerType = ''
  for (var c of _cargoTypeInputList) {
    if (data[column.dataField] === c.code) {
      containerType = c.chineseName
      break
    }
  }
  return containerType
}

/**
 * @public
 * 业务类型 空运进口
 */
export function containerTypeAirLabFun(data, column) {
  var type = Number(data[column])
  if (type === 0) {
    return '一主多分'
  } else if (type === 1) {
    return '直单'
  } else {
    return '一主一分'
  }
}

/**
 * 如果字段值是为空，则返回也为空，因为空字段经int强转之后为0，此时会匹配上"一主多分"
 */
export function containerTypeAirStrFun(data, column) {
  var containerTypeStr = ''
  if (data[column.dataField]) {
    var type = Number(data[column])
    for (var c of _cargoTypeAirInputList) {
      if (type === c.code) {
        containerTypeStr = c.chineseName
        break
      }
    }
  }
  return containerTypeStr
}

/**
 * 揽货类型
 */
export function cargoSourceLabelFunc(data, column) {
  if (data.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
    return '自揽货'
  } else {
    return '指定货'
  }
}

/**
 *  @private
 *  返回月份
 */
export function returnMonth(month) {
  var strValue = ''
  switch (month) {
    case 0:
      strValue = '1'
      break
    case 1:
      strValue = '2'
      break
    case 2:
      strValue = '3'
      break
    case 3:
      strValue = '4'
      break
    case 4:
      strValue = '5'
      break
    case 5:
      strValue = '6'
      break
    case 6:
      strValue = '7'
      break
    case 7:
      strValue = '8'
      break
    case 8:
      strValue = '9'
      break
    case 9:
      strValue = '10'
      break
    case 10:
      strValue = '11'
      break
    case 11:
      strValue = '12'
      break
    default:
  }
  return strValue
}
